import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import UserLockers from '../components/UserLockers';
import UserDetailsComponent from '../components/UserDetailsComponent';
import { getSecureItemFromSpecificStorage } from '../lib/BrowserStorageAccessMiddleware';
import {
  LOCAL_STORAGE,
  LS_LOCKER_BANK_INFO,
  LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS,
  USER_INFO,
  USER_LOCATION_DETAILS,
} from '../assets/constants/BrowserStorageKeys';
import CircularProgressLoader from '../components/CircularProgressLoader';
import ButtonComponent from '../components/ButtonComponent';
import { useTranslation } from 'react-i18next';
import { getPathForNextPage, getUnitLabelParams } from '../lib/Utils';
import { HOME, USER_ACCOUNT } from '../assets/constants/PageList';
import ShowToast from '../components/ToastComponent';
import { ASSET_RENTAL_USE_CASE, TOAST_ERROR } from '../assets/constants/Constants';
import {
  fetchNearbyLockersForLocation,
  getCurrentBrowserLocation,
  getNearbyLockerErrorMessage,
} from '../lib/NearbyLockerUtils';

export default function UserProfilePage() {
  const history = useHistory();
  const { t } = useTranslation();
  const [userInfo, setUserInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingMessage, setLoadingMessage] = useState(t('loading_text'));
  const settings = getSecureItemFromSpecificStorage(LOCAL_STORAGE,LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS)
  const lockerBankInfo = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_LOCKER_BANK_INFO);
  const isAssignmentPricingEnabled = settings?.is_pricing;
  const isAssetRentalUseCase = settings?.usecase === ASSET_RENTAL_USE_CASE;
  const [isAuthementicatedUser, setIsAuthenticatedUser] = useState(false);
  console.log("isAssetRentalUseCase", isAssetRentalUseCase)

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        setLoadingMessage(t('getting_user_data_text'));

        const user = await getSecureItemFromSpecificStorage(
          LOCAL_STORAGE,
          USER_INFO
        );

        if (user) {
          setUserInfo(user);
          setIsAuthenticatedUser(true);
        } else {
          setUserInfo({
            username: 'Guest User',
            email: "NA",
            mobile_number: '',
            date_joined: '',
          });
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoadingMessage(t('something_went_wrong_text'));
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [t]);

  const redirectToMap = (locationDetails = null, lockersData = null) => {
    history.push({
      pathname: '/map',
      state: {
        ...(locationDetails && {
          center: locationDetails,
          useUserLocation: true,
        }),
        ...(lockersData && {
          lockersData,
          timestamp: Date.now(),
        }),
      },
    });
  };

  const fetchNearbyLockersAndRedirect = async (userLocation) => {
    const { lockersData } = await fetchNearbyLockersForLocation({
      userLocation,
      onLoadingMessage: setLoadingMessage,
    });

    redirectToMap(userLocation, lockersData);
    return true;
  };

  const handleToMapRedirect = async () => {
    const storedUserLocation = getSecureItemFromSpecificStorage(
      LOCAL_STORAGE,
      USER_LOCATION_DETAILS
    );

    if (
      storedUserLocation?.lat &&
      storedUserLocation?.lng
    ) {
      try {
        setIsLoading(true);
        await fetchNearbyLockersAndRedirect(storedUserLocation);
      } catch (error) {
        console.error('Locker fetch error:', error);
        ShowToast(getNearbyLockerErrorMessage(error), TOAST_ERROR);
      } finally {
        setIsLoading(false);
      }
      return;
    }

    setIsLoading(true);
    setLoadingMessage(t('info_Message_Getting_Location'));

    try {
      const userLocation = await getCurrentBrowserLocation();
      await fetchNearbyLockersAndRedirect(userLocation);
    } catch (error) {
      console.error('Location or locker fetch error:', error);
      ShowToast(getNearbyLockerErrorMessage(error), TOAST_ERROR);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className='user-profile-page'>
      {isLoading ? (
		<div className='main'>
			<CircularProgressLoader message={loadingMessage} />
		</div>
      ) : (
        <div className='main'>
          <div className='heading-container'>
            <h1 className='heading'>{t('my_account_title')}</h1>
            <p className='paragraph'>
              {t('text_manage_your_booking_details_and_account_info')}
            </p>
          </div>
        
          {!isAssetRentalUseCase && <div className='user-details-container'>
            <UserDetailsComponent
              userInfo={userInfo}
              onUserInfoUpdate={setUserInfo}
              isAuthenticatedUser={isAuthementicatedUser}
            />
          </div>}
          {((isAssignmentPricingEnabled || isAssetRentalUseCase ) && isAuthementicatedUser )&&
        <>
        {isAssignmentPricingEnabled && <>
          <div className='user-profile-actions'>
            <div className='actions-title'>{t('quick_actions_title')}</div>
            <div className='actions-buttons'>
              <ButtonComponent
                handleClick={handleToMapRedirect}
                title={t('book_in_advance', getUnitLabelParams(lockerBankInfo?.LockerBankType, t))}
              />
              <ButtonComponent
                handleClick={() => history.push(getPathForNextPage(USER_ACCOUNT, HOME))}
                title={t('active_bookings')}
              />
            </div>
          </div>
          </>
          }
          <div className='user-lockers-container'>
			        <UserLockers initialTab={history.location.state?.activeTab} hideUpcomingTab={isAssetRentalUseCase} />
          </div>
          </>
          }
        </div>
      )}

    </div>
  );
}
